export default __webpack_public_path__ + "images/58a2b2828fb238cfb391d92558aee3fa.svg";